/** Product shell config for Lone Peak Holdings apps. */

export interface LphLink {
  code: string;
  name: string;
  url: string;
}

export interface LphSiteConfig {
  productCode: string;
  productName: string;
  domainHtml: string;
  links: LphLink[];
  logoutUrl: string;
}

export const fp3SiteConfig: LphSiteConfig = {
  productCode: 'FP3',
  productName: 'Fleet Directory',
  domainHtml: 'fp3',
  links: [
    {
      code: 'FLY',
      name: 'Flight Tracker',
      url: import.meta.env.VITE_FLY_APP_URL || 'https://fly.n321sd.com',
    },
    {
      code: 'FM',
      name: 'Financial Management',
      url: import.meta.env.VITE_FM_APP_URL || 'https://fm.n321sd.com',
    },
    {
      code: 'HOME',
      name: 'N321SD Home Page',
      url: import.meta.env.VITE_HOME_URL || 'https://n321sd.com',
    },
  ],
  logoutUrl: import.meta.env.VITE_LOGOUT_URL || '/logout',
};
